// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yKzv0","logo":"styles_logo__SnciM"};